import axios from "axios";
import { COMMON_TV_BASE_URL } from "./Url";

export function parseTokenClaims(token) {
    if (!token) return null;
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return null;
        const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(b64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(json);
    } catch (e) {
        return null;
    }
}

export function getCurrentTokenClaims() {
    const token = localStorage.getItem('token');
    return parseTokenClaims(token);
}

const getHeaders = () => {
    const token = localStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token && token.trim() !== '') {
        headers['Authorization'] = 'Bearer ' + token;
    }
    return headers;
};

// Global interceptor to handle session expiration or stale tokens
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const errCode = error.response.data?.error_code;
            if (errCode === 'session_error' || errCode === 'token_expired' || errCode === 'token_invalid') {
                if (window.location.pathname !== '/login' && !window.location.pathname.includes('/client/login')) {
                    console.warn("Session expired or invalid. Redirecting to login...");
                    localStorage.removeItem('token');
                    window.location.href = '/login?expired=1';
                }
            }
        }
        return Promise.reject(error);
    }
);

// High-level safe API calls - isolation is 100% server-enforced based on the Bearer JWT token
export function getTvListCall(data = {}) {
    return axios.post(COMMON_TV_BASE_URL + 'list', data, { headers: getHeaders() });
}

export function storeTvCall(data) {
    return axios.post(COMMON_TV_BASE_URL + 'store', data, { headers: getHeaders() });
}

export function updateTvCall(data) {
    return axios.post(COMMON_TV_BASE_URL + 'update', data, { headers: getHeaders() });
}

export function deleteTvCall(data) {
    return axios.post(COMMON_TV_BASE_URL + 'delete', data, { headers: getHeaders() });
}

export function getTvAdsCall(tvId = null) {
    const payload = tvId ? { tv_id: tvId } : {};
    return axios.post(COMMON_TV_BASE_URL + 'ads', payload, { headers: getHeaders() });
}

export function storeTvAdCall(data) {
    return axios.post(COMMON_TV_BASE_URL + 'ads/store', data, { headers: getHeaders() });
}

export function updateTvAdCall(data) {
    return axios.post(COMMON_TV_BASE_URL + 'ads/update', data, { headers: getHeaders() });
}

export function deleteTvAdCall(data) {
    return axios.post(COMMON_TV_BASE_URL + 'ads/delete', data, { headers: getHeaders() });
}

export function uploadTvAdImageCall(data) {
    return axios.post(COMMON_TV_BASE_URL + 'ads/upload', data, { headers: getHeaders() });
}

export function uploadTvLogoCall(data) {
    return axios.post(COMMON_TV_BASE_URL + 'logo/upload', data, { headers: getHeaders() });
}
